export default __webpack_public_path__ + "static/capabilitiesImg4-5b9bc43ec693394e847b55d32581329c.webp";